<template>
  <div :class="['drag-dialog', {'drag-dialog-call':user.enableCall &&isCall},{'drag-dialog-no-thrad':hideThread}]" v-dialogDrag @click.stop>
    <div class="drag-header" :class="{'hq-drag-header':HQ}">
      <span class="title">{{hideThread?'':"详情"}}</span>
      <span class="close" @click="closeReportDialog">
        <i class="el-icon-close"></i>
      </span>
    </div>
    <div class="drag-main-wrap">
      <el-scrollbar ref='dragMain' wrap-class="drag-main" v-if="!hideThread" v-loading="loading">
        <thread :disabled="disabled" v-if="thread||callStarted" ref="thread" :confirm="confirm" @isConfirm='isConfirm'></thread>
      </el-scrollbar>
      <call class="drag-call" :clues="clues" v-if="user.enableCall" :isCall="isCall" v-show="isCall"></call>
      <transition name="el-fade-in">
        <div class="confirm confirm-call" v-if="confirm">
          <p class="title">
            <i class="el-icon-close" @click="cancelConfirm"></i>
          </p>
          <p class="text">确定要删除本条跟进记录？</p>
          <p class="btns">
            <span class="save" :class="{'hq-save':HQ}" @click="nextConfirm">确定</span>
            <span @click="cancelConfirm">取消</span>
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { eventHub } from "../../common/utils.js";
import thread from "./thread.vue";
import call from "./call.vue";
import { mapGetters, mapState } from "vuex";
export default {
  name: "threadDialog",
  props: ["clues", "disabled"],
  components: {
    thread,
    call
  },
  data () {
    return {
      loading: false,
      hideThread: false,
      confirm: false,
      callstatus: 0,
      HQ: __VERSION === 'HQ'
    };
  },
  computed: {
    ...mapState({
      callInfo: state => state.callInfo.callInfo,
      callStatus: state => state.callInfo.callStatus,
      user: state => state.account.baseInfo,
      isAddedClue: state => state.callInfo.reportObj.isAddedClue,
      reportObj: state => state.callInfo.reportObj,
      callStarted: state => state.callInfo.callStarted,
      thread: state => state.callInfo.thread
    }),
    isCall () {
      const path = this.$route.path;
      if (path == '/pool') {
        return this.callStarted
      } else {
        return this.isAddedClue != 2
      }
    }
  },
  watch: {
    thread (val) {
      if (!val) {
        this.ininDialog();
      }
    },
    callStarted (val) {
      if (!val) {
        this.ininDialog();
      }
    },
    callStatus (val) {
      if (val == "start") {
        this.confirm = false;
      }
    },
    callstatus (val, oldVal) {
      if (oldVal == 2 && val == 0) {
        this.confirm = false;
      }
    },
    callInfo (val) {
      // console.log(val)
      if (val) {
        let isPath = this.callInfo.path.indexOf("/report") == -1;
        let isHide = !(
          this.isAddedClue == 1 ||
          (this.isAddedClue == 2 && this.role == "mainaccount")
        );
        this.hideThread = isPath ? true : isHide;
      }
    },
    isAddedClue (val) {
      if (val === 1) {
        this.hideThread = false;
      }
    }
  },
  mounted () {
    eventHub.$on("callstatus", this.handCallstatus);
    eventHub.$on("isConfirm", this.isConfirm);
    eventHub.$on("closeReportDialog", this.closeReportDialog);

  },
  beforeDestroy () {
    eventHub.$off("callstatus");
    eventHub.$off("isConfirm");
    eventHub.$on("closeReportDialog");

  },
  methods: {
    ininDialog () {
      let target = document.querySelectorAll(".drag-dialog")[0];
      target.style.top = "50%";
      target.style.left = "50%";
    },
    handCallstatus (val) {
      this.callstatus = val;
    },
    cancelConfirm () {
      this.confirm = false;
      this.$refs.thread.cancelConfirm();
      /* 我的线索修改线索后刷新列表 */
      if (this.$route.path == '/pool') {
        this.$store.commit("setCloseCard", false);
      }
    },
    nextConfirm () {
      this.$refs.thread.deleteTrailNote();
      /* 我的线索修改线索后刷新列表 */
      // console.log(this.$route.path)
      if (this.$route.path == '/pool') {
        this.$store.commit("setCloseCard", true);
      }
    },
    isConfirm (whether) {
      this.confirm = whether;
    },
    /* 重置跟进信息 */
    initThread () {
      let path = this.$route.path;
      if (path.indexOf("report/") != -1 && path.indexOf("/pool") != -1) {
        this.$store.commit("setReportObj", { isAddedClue: 0, id: null });
      }
    },
    async closeReportDialog () {
      let existCall =
        this.permissions.indexOf("callRecords") != -1 && this.user.enableCall;
      let existThread =
        this.isAddedClue == 1 ||
        (this.isAddedClue == 2 && this.role == "mainaccount");
      if (!this.callStarted) {
        this.confirm = false;
        this.$store.commit("setThread", false);
        this.initThread();
      }
      if (existCall) {
        return this.connectionFree();
      }
      if (existThread) {
        let path = this.$route.path;
        this.confirm = false;
        this.$store.commit("setThread", false);
        this.$store.commit("setCallInfo", "");
        this.initThread();
        return;
      }
      // this.$store.commit("setCallInfo", "");
      if (window.location.pathname == this.path) {
        if (
          this.path != "/sea" &&
          this.path != "/task" &&
          this.path != "/recycle" &&
          this.path != "/pool"
        ) {
          this.$store.commit("setUpdateName", "report");
        }
      }
    },
    connectionFree () {
      if (this.callStarted && this.callstatus != 2) {
        return this.$message.warning("您正在使用话机，请先挂断话机");
      } else {
        this.confirm = false;
        this.$store.commit("setThread", false);
        this.$store.commit("setCallInfo", "");
        this.initThread();
      }
    },
    fetchJsonp (url) {
      let body = document.getElementsByTagName("body")[0];
      let script = document.createElement("script");
      script.setAttribute("src", url);
      script.setAttribute("id", "connect");
      body.appendChild(script);
    },
    removeEle (id) {
      let body = document.getElementsByTagName("body")[0];
      let ele = document.getElementById(id);
      body.removeChild(ele);
    }
  },
  directives: {
    dialogDrag: {
      bind (el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector(".drag-header");
        const dialogHeaderElParent = el.querySelector(".drag-header")
          .parentNode;
        const dragDom = el;
        dialogHeaderEl.style.cursor = "move";
        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty =
          dragDom.currentStyle || window.getComputedStyle(dragDom, null);
        dialogHeaderEl.onmousedown = e => {
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX = e.clientX - dialogHeaderEl.offsetLeft;
          const disY = e.clientY - dialogHeaderEl.offsetTop;
          // 鼠标按下，计算当前元素到自身边界距离左、上
          const leftX = e.offsetX;
          const topY = e.offsetY;
          // 移动的临界点
          const [elHeight, elWidth, bodyHeight, bodyWidth] = [
            el.clientHeight,
            el.clientWidth,
            window.innerHeight,
            document.body.clientWidth
          ];
          let [boundLeft, boundtop, boundRight, boundBottom] = [
            elWidth / 2,
            elHeight / 2,
            bodyWidth - elWidth + elWidth / 2,
            bodyHeight - elHeight + elHeight / 2 - 5
          ];
          // 获取到的值带px 正则匹配替换
          let styL, styT;
          // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
          if (sty.left.includes("%")) {
            styL =
              +document.body.clientWidth * (+sty.left.replace(/\%/g, "") / 100);
            styT =
              +document.body.clientHeight * (+sty.top.replace(/\%/g, "") / 100);
          } else {
            styL = +sty.left.replace(/\px/g, "");
            styT = +sty.top.replace(/\px/g, "");
          }
          document.onmousemove = function (e) {
            // 通过事件委托，计算移动的距离
            const l = e.clientX - disX;
            const t = e.clientY - disY;
            let left = l + styL;
            let top = t + styT;
            // 移动当前元素
            dragDom.style.left = `${
              left < boundLeft
                ? boundLeft
                : left > boundRight ? boundRight : left
              }px`;
            dragDom.style.top = `${
              top < boundtop ? boundtop : top > boundBottom ? boundBottom : top
              }px`;
            //将此时的位置传出去
            // console.log({
            //   boundLeft: boundLeft,
            //   top: top,
            //   boundtop: boundtop,
            //   boundRight: boundRight,
            //   boundBottom
            // });
            // console.log({x:e.pageX,y:e.pageY})
            //binding.value({x:e.pageX,y:e.pageY})
          };
          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.drag-dialog {
  width: 480px;
  height: 680px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -240px;
  margin-top: -340px;
  background-color: #ffffff;
  box-shadow: 1.5px 4.8px 10px 0 rgba(0, 0, 0, 0.2);
  z-index: 1003;
  &.drag-dialog-call {
    width: 760px;
    margin-left: -380px;
  }
  &.drag-dialog-no-thrad {
    width: 376px;
    height: 624px;
    margin-top: -312px;
    margin-left: -188px;
    .drag-header {
      background: #fff;
      height: 30px;
      padding: 15px 20px;
      span {
        &.close {
          color: #999;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
    .drag-call {
      width: 336px;
      margin: 0 auto;
      box-shadow: 0px 0px 0px 0 rgba(0, 0, 0, 0.2);
    }
  }
}
.drag-main-wrap {
  display: flex;
  justify-content: space-between;
  height: 624px;
  overflow-y: hidden;
}
.drag-header {
  // width: 480px;
  height: 56px;
  padding: 20px;
  background-color: var(--auxiliary-bg-color);
  display: flex;
  justify-content: space-between;
  span {
    align-self: center;
    &.title {
      color: #ffffff;
    }
    &.close {
      color: #d3e1f1;
      cursor: pointer;
    }
  }
  &.hq-drag-header {
    background-color: #f8f8f8;
    span {
      align-self: center;
      &.title {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
      }
      &.close {
        color: #333333;
        cursor: pointer;
        &:hover {
          color: #666666;
        }
      }
    }
  }
}
.drag-call {
  width: 280px;
  height: 624px;
  box-shadow: 0px 0px 10px 0 rgba(0, 0, 0, 0.2);
}
.confirm {
  width: 239px;
  height: 110px;
  border-radius: 4px;
  box-shadow: 0.7px 0.7px 10px 0 rgba(0, 0, 0, 0.18);
  background-color: #ffffff;
  border: solid 1px #ececec;
  position: absolute;
  left: 50%;
  margin-left: -120px;
  top: 50%;
  margin-top: -55px;
  z-index: 10000;
  .title {
    text-align: right;
    font-size: 10px;
    color: #a9a9a9;
    padding: 5px;
    i {
      cursor: pointer;
    }
  }
  .text {
    padding: 0 25px;
    font-size: 14px;
    color: var(--text-content-color);
  }
  .btns {
    padding: 0 25px;
    margin-top: 20px;
    span {
      display: inline-block;
      cursor: pointer;
      color: var(--text-auxiliary-color);
    }
    .save {
      padding: 10px 9px;
      color: #fff;
      border-radius: 2px;
      background-color: var(--theme-color);
      margin-right: 19px;
      &.hq-save {
        background-color: #e15151;
        &:hover {
          background-color: #f75353;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.drag-main-wrap {
  .el-scrollbar {
    width: 480px;
    .drag-main {
      box-sizing: content-box;
      padding: 20px;
      max-height: 600px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/threadDialog.vue